module.exports = {
  primary: 'Roboto, sans-serif',
  secondary: 'Consolas, Liberation Mono, Menlo, Courier, monospace',
};
